import { render, staticRenderFns } from "./Company_establishments.vue?vue&type=template&id=5fbd3293&lang=pug&"
import script from "./Company_establishments.vue?vue&type=script&lang=coffee&"
export * from "./Company_establishments.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports